import ServiceLayout from "./ServiceLayout";
import { Typography, Box } from "@mui/material";
import { Helmet } from "react-helmet-async";

const LandscapeMaintenance = () => {
  return (
    <>
      <Helmet>
        <title>Garden Care & Maintenance | KRM Landscape</title>
        <meta
          name="description"
          content="Complete garden care and landscape maintenance services by KRM Landscape to keep your outdoor spaces healthy and beautiful."
        />
        <meta
          name="keywords"
          content="garden care, landscape maintenance, lawn mowing, pruning, weeding, fertilization, irrigation management, pest control, KRM Landscape"
        />
      </Helmet>

      <ServiceLayout title="Garden Care & Maintenance">

        {/* Hero Image */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Box
            component="img"
            src="/images/maintenance.jpeg"
            alt="Garden Care & Maintenance by KRM Landscape"
            sx={{
              width: { xs: "100%", md: "80%" },
              maxHeight: "400px",
              objectFit: "contain",
              borderRadius: "12px",
              mx: "auto",
              display: "block",
            }}
          />
        </Box>

        <Typography paragraph>
          Our garden care and maintenance services are focused on nurturing healthy,
          well-balanced, and visually pleasing gardens throughout the year. We ensure
          that every plant, lawn, and green element receives the attention it needs to
          grow and flourish naturally.
        </Typography>

        <Typography paragraph>
          Our services include routine lawn mowing, trimming, pruning, weeding,
          soil conditioning, fertilization, and irrigation management. We also
          implement effective pest and disease control measures to protect plants
          and maintain long-term garden health.
        </Typography>

        <Typography paragraph>
          Whether it’s a home garden, terrace garden, commercial property, or
          community green space, our experienced team follows structured maintenance
          practices to preserve beauty, balance, and sustainability in every garden.
        </Typography>

        <Typography paragraph>
          With KRM Landscape’s garden care and maintenance services, you can enjoy a
          fresh, clean, and thriving garden without the stress of upkeep while we
          take care of every detail with professionalism, consistency, and care.
        </Typography>


      </ServiceLayout>
    </>
  );
};

export default LandscapeMaintenance;
